import React from "react";

import ThankYou from "../../../modules/signUp/components/ThankYou/ThankYou";

export function ThankYouPage() {
  return <ThankYou />;
}
